var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { rolesApi } from "../../../api/enpoints/roles-api";
// Helper function to clean filter values
const cleanFilters = (filters) => {
    const cleaned = {};
    Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (Array.isArray(value)) {
            cleaned[key] = value.length > 0 ? value : undefined;
        }
        else if (value === "" || value === null) {
            cleaned[key] = undefined;
        }
        else if (value !== undefined) {
            cleaned[key] = value;
        }
    });
    return cleaned;
};
// Get all roles thunk
export const getAllRoles = createAsyncThunk("roles/getAllRoles", (query_1, _a) => __awaiter(void 0, [query_1, _a], void 0, function* (query, { rejectWithValue }) {
    var _b, _c;
    try {
        const cleanedQuery = Object.assign(Object.assign({}, query), { filters: cleanFilters(query.filters) });
        const response = yield rolesApi.getAllRoles(cleanedQuery);
        if (response.data.isSuccess && response.data.data) {
            return response.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch roles");
        }
    }
    catch (error) {
        const errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch roles";
        return rejectWithValue(errorMessage);
    }
}));
export const createNewRole = createAsyncThunk("roles/createNewRole", (roleData_1, _a) => __awaiter(void 0, [roleData_1, _a], void 0, function* (roleData, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield rolesApi.createNewRole(roleData);
        if (response.data.isSuccess) {
            return response.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to create role");
        }
    }
    catch (error) {
        const errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to create role";
        return rejectWithValue(errorMessage);
    }
}));
export const updateRole = createAsyncThunk("roles/updateRole", (roleData_1, _a) => __awaiter(void 0, [roleData_1, _a], void 0, function* (roleData, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield rolesApi.updateRole(roleData);
        if (response.data.isSuccess) {
            return response.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to update role");
        }
    }
    catch (error) {
        const errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to update role";
        return rejectWithValue(errorMessage);
    }
}));
export const deleteRole = createAsyncThunk("roles/deleteRole", (id_1, _a) => __awaiter(void 0, [id_1, _a], void 0, function* (id, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield rolesApi.deleteRole(id);
        if (response.data.isSuccess) {
            return Object.assign(Object.assign({}, response.data), { id });
        }
        else {
            return rejectWithValue(response.data.message || "Failed to delete role");
        }
    }
    catch (error) {
        const errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to delete role";
        return rejectWithValue(errorMessage);
    }
}));
// Toggle role status thunk
export const toggleRoleStatus = createAsyncThunk("roles/toggleRoleStatus", (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ id, isActive }, { rejectWithValue }) {
    var _c, _d;
    try {
        const response = yield rolesApi.toggleRoleStatus({ id, isActive });
        if (response.data.isSuccess) {
            return Object.assign(Object.assign({}, response.data), { id, isActive });
        }
        else {
            return rejectWithValue(response.data.message || "Failed to update role status");
        }
    }
    catch (error) {
        const errorMessage = ((_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to update role status";
        return rejectWithValue(errorMessage);
    }
}));
// Get all roles summary thunk
export const getAllRolesSummary = createAsyncThunk("roles/getAllRolesSummary", (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield rolesApi.getAllRolesSummary();
        if (response.data.isSuccess) {
            return response.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch roles summary");
        }
    }
    catch (error) {
        const errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch roles summary";
        return rejectWithValue(errorMessage);
    }
}));
// Get role by ID thunk
export const getRoleById = createAsyncThunk("roles/getRoleById", (id_1, _a) => __awaiter(void 0, [id_1, _a], void 0, function* (id, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield rolesApi.getRoleById(id);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch role");
        }
    }
    catch (error) {
        const errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch role";
        return rejectWithValue(errorMessage);
    }
}));
// Get roles dropdown thunk
export const getRolesDropdown = createAsyncThunk("roles/getRolesDropdown", (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield rolesApi.getRolesDropdown();
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        else {
            return rejectWithValue(response.data.message || "Failed to fetch roles dropdown");
        }
    }
    catch (error) {
        const errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Failed to fetch roles dropdown";
        return rejectWithValue(errorMessage);
    }
}));
